import { Box, Breadcrumbs } from "@common-ui/ui";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

export const ProfileBreadcrumbs = (props) => {
    return (
        <Box sx={{
            borderBottom: "1px solid #EBEBEB",
            padding: "1rem 2rem 0.5rem",
            background: "#fff"
        }}>
            <Breadcrumbs maxItems={2} aria-label="breadcrumb" separator={<NavigateNextIcon fontSize="small" />}>
                {props.children}
            </Breadcrumbs>
        </Box>
    );
}